module.exports = __webpack_public_path__ + "img/hbar.35b79537.svg";